<template>
    <USeparator class="my-4"/>
    <div class="p-4 overflow-y-auto h-full">
        <div class="max-w-[600px]">
            <assignment-details v-if="!isLoading && assignment" :assignment-uuid="assignmentUuid" :is-list-view="false"/>
            <loading-bar v-else-if="isLoading"/>
            <div v-else>Ingen data</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import AssignmentDetails from '@/assignments/details/AssignmentDetails.vue'
import {onMounted, ref, watch} from 'vue'
import {notifyError} from '@/services/infrastructure/notification.service'
import {Assignment} from '@/assignments/Assignment.type'
import {findByAssignmentUuid} from '@/assignments/assignment.service'

const props = defineProps({
    assignmentUuid: {
        type: String,
        required: true
    }
})

const isLoading = ref(false)
const assignment = ref<Assignment>()

const fetchAssignment = async (assignmentUuid: string) => {
    try {
        assignment.value = await findByAssignmentUuid(assignmentUuid)
    } catch (error) {
        notifyError({title: 'Klarte ikke å hente oppgave', description: {error, descriptionMessage: ''}})
    } finally {
        isLoading.value = false
    }
}

watch(
    () => props.assignmentUuid,
    async (newValue) => {
        await fetchAssignment(newValue)
    }
)

onMounted(async () => {
    await fetchAssignment(props.assignmentUuid)
})

</script>

<style scoped>

</style>